import api from './api';

// Garages (per project/building, linked to entrances)
export const getGaragesApi = params => {
  return api.get('/garages', {params});
};

export const getGaragesByBuildingApi = (buildingId, params) => {
  return api.get(`/garages/building/${buildingId}`, {params});
};

export const getGarageByIdApi = id => {
  return api.get(`/garages/${id}`);
};

export const addGarageApi = params => {
  return api.post('/garages', params);
};

export const editGarageApi = params => {
  return api.put('/garages', params);
};

export const deleteGarageApi = id => {
  return api.delete(`/garages/${id}`);
};

// Customer garages (optional report-only data on a customer)
export const getCustomerGaragesApi = customerId => {
  return api.get(`/customer-garages/customer/${customerId}`);
};

export const addCustomerGarageApi = params => {
  return api.post('/customer-garages', params);
};

export const editCustomerGarageApi = params => {
  return api.put('/customer-garages', params);
};

export const deleteCustomerGarageApi = id => {
  return api.delete(`/customer-garages/${id}`);
};

// Reports > Garages
export const getGarageReportApi = params => {
  return api.get('/customer-garages/report', {params});
};

export const getGarageReportFiltersApi = params => {
  return api.get('/customer-garages/report/filters', {params});
};

// Excel/CSV download of the garage report with the same filters (format: 'xlsx' | 'csv').
export const exportGarageReportApi = (params, format = 'xlsx') => {
  return api.get('/customer-garages/report/export', {
    params: {...params, format},
    responseType: 'blob',
  });
};
